import { capitalCase } from 'change-case';

const tableColumnsFormatter = column => capitalCase(column);

export default tableColumnsFormatter;
